import { useEffect } from "react"
import HtmlParser from "react-html-parser"
import { metadata, TEXT_BUTTON } from "lacinetek-common/src/metadata"

import { useTranslation } from "lib/i18n/translation"
import { useModal } from "lib/modal"

import { BlockOverlay } from "components/modals/svod/block-overlay"
import { BlockHeader } from "components/subscription/block-header"
import { BlockQuote } from "components/subscription/block-quote"
import { BlockTitle } from "./block-title"
import { DisplaySliders } from "./slider"
import { BlockText } from "./block-text"

export const Thematics = ({ block, className, overlayAuto }) => {
	const { show } = useModal()
	const { c } = useTranslation()

	const handleThematicModal = (event, block) => {
		event.preventDefault()
		show({
			id: "thematic-overlay",
			children: <BlockOverlay block={block} />,
			className: "is-archive modal stackable"
		})
	}

	useEffect(() => {
		if (overlayAuto) {
			show({
				id: "thematic-overlay",
				children: <BlockOverlay block={block} />,
				className: "is-archive modal stackable"
			})
		}
	}, [])

	return (
		<section id={block.id} className={className}>
			<BlockTitle block={block} />
			{
				block.description
				&& HtmlParser(block.description)
			}
			<BlockHeader block={block} />
			<BlockQuote block={block} />
			<BlockText block={block} />
			<DisplaySliders rails={block.children.items} />
			{
				metadata(block, TEXT_BUTTON)
				&& <p className="section-link centered">
					<a
						href="#"
						rel="nofollow noopener"
						title={c("see-all-articles")}
						className="button"
						onClick={event => handleThematicModal(event, block)}
					>
						{metadata(block, TEXT_BUTTON)}
					</a>
				</p>
			}
		</section>
	)
}
